import { useLocation } from 'react-router-dom';

const titles: Record<string, string> = {
  '/portal': 'Dashboard',
  '/talleres': 'Talleres Vinculados',
  '/perfil': 'Mi Perfil',
};

export function useProveedorPageTitle(): string {
  const { pathname } = useLocation();

  // Exact match first
  if (titles[pathname]) return titles[pathname];

  // Detail routes
  if (pathname.startsWith('/portal/')) return 'Detalle de Cotizacion';

  return 'Portal Proveedores';
}
